import { MutableRefObject, useEffect, useRef } from 'react';

export const useLatestRef = <T>(value: T): MutableRefObject<T> => {
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref;
};
